module.exports = __webpack_public_path__ + "img/Virtualization.ae37b809.svg";